import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class GetCollectionService {

  constructor(private firestore: AngularFirestore) { }

  create_NewStudent(tableName,record) {
    return this.firestore.collection(tableName).add(record);
  }

  read_Students(tableName) {
    return this.firestore.collection(tableName).snapshotChanges();
  }

  update_Student(tableName,recordID,record){
    this.firestore.doc(tableName+'/' + recordID).update(record);
  }

  delete_Student(tableName,record_id) {
    this.firestore.doc(tableName+'/' + record_id).delete();
  }

}
